const SEBI_FITYPES = [
	"SIP", 
	"EQUITIES", 
	"MUTUAL_FUNDS", 
	"ETF", 
	"IDR", 
	"CIS", 
	"AIF", 
	"INVIT", 
	"REIT", 
	"BONDS", 
	"DEBENTURES"
  ];
  
  const INSURANCE_FITYPES = [
	"GENERAL_INSURANCE", 
	"LIFE_INSURANCE"
  ];  

//Convert consent start days to ISO 8601 format
export const getConsentStartDate = (days) => {
	const currentDate = new Date();
	const millisecondsInDay = 24 * 60 * 60 * 1000;
	const daysNum = parseInt(days);
	if (daysNum === 0) {
		return currentDate.toISOString();
	} else {
		const futureDate = new Date(
			currentDate.getTime() + daysNum * millisecondsInDay
		);
		return futureDate.toISOString();
	}
};

//Convert consentExpiry format to ISO 8601 format
export const getConsentExpiryDate = (consentStart, value, unit) => {
	const formattedStartDate = getConsentStartDate(consentStart);
	const startDate = new Date(formattedStartDate);
	let endDate = new Date(startDate);

	switch (unit) {
		case 'DAY':
			endDate.setDate(startDate.getDate() + parseInt(value));
			break;
		case 'MONTH':
			endDate.setMonth(startDate.getMonth() + parseInt(value));
			break;
		case 'YEAR':
			endDate.setFullYear(startDate.getFullYear() + parseInt(value));
			break;
		case 'INF':
			endDate = null;
			break;
		default:
			throw new Error('Invalid unit value');
	}

	return endDate ? endDate.toISOString(): 'INF';
};

//Convert data range from months to ISO 8601 format
export const dataRangeFrom = (months) => {
	const currentDate = new Date();
	const previousDate = new Date(currentDate);
	
	if (parseInt(months) !== 0) {
		previousDate.setMonth(previousDate.getMonth() - parseInt(months));
	}
	
	return previousDate.toISOString();
};

//Convert data range to months to ISO 8601 format
export const dataRangeTo = (months) => {
	const currentDate = new Date();
	const nextDate = new Date(currentDate);
	nextDate.setMonth(nextDate.getMonth() + parseInt(months));

	return nextDate.toISOString();
};

//Converts DD/MM/YYYY to DD month_name YYYY
export const getMonthFormatDate = (dateString) => {
	let dateParts = dateString?.split('/');
	if (dateParts?.length !== 3) {
		dateParts = dateString?.split('-');
	}

	let year, month, day;
	if (dateParts[0]?.length === 4) {
		// year is in the first part
		year = dateParts[0];
		month = dateParts[1] - 1;
		day = dateParts[2];
	} else {
		// year is in the last part
		year = dateParts[2];
		month = dateParts[1] - 1;
		day = dateParts[0];
	}

	const date = new Date(year, month, day);
	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	const monthName = monthNames[date.getMonth()];

	return `${day} ${monthName} ${year}`;
};

//Converts Date-Picker date time format to YYYY-MM-DD
export const formatDate = (dateString) => {
	const dateObj = new Date(dateString);

	const year = dateObj.getFullYear();
	const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
	const day = dateObj.getDate().toString().padStart(2, '0');

	const formattedDate = `${year}-${month}-${day}`;
	return formattedDate;
};

//Converts date from ISO 8601 to DD/MM/YYYY HH:MM:SS AM/PM format
export const getTimestamp = (timestamp) => {
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	const hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const seconds = date.getSeconds().toString().padStart(2, '0');

	const ampm = hours >= 12 ? 'PM' : 'AM';
	const twelveHour = hours % 12 || 12;

	return `${day}/${month}/${year} ${twelveHour}:${minutes}:${seconds} ${ampm}`;
};

//Compare dates in ISO format
export const getEarlierTime = (time1, time2) => {
	const earlierTime = new Date(Math.min(new Date(time1), new Date(time2)));
	return earlierTime.toISOString();
};

//Add days to ISO format
export const addDays = (time, days) => {
	const dateFormat = new Date(time);
	dateFormat.setDate(dateFormat.getDate() + parseInt(days));
	return dateFormat.toISOString();
};

//Subtract hours from ISO format
export const subtractHours = (time, hours) => {
	const dateFormat = new Date(time);
	dateFormat.setHours(dateFormat.getHours() - parseInt(hours));
	return dateFormat.toISOString();
};

//Converts Calendar time to YYYY-MM-DDTHH:MM:SS format
export const getGraphTimeFormat = (dateString) => {
	const dateObj = new Date(dateString);

	const year = dateObj.getFullYear();
	const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
	const day = dateObj.getDate().toString().padStart(2, '0');
	const hours = dateObj.getHours().toString().padStart(2, '0');
	const minutes = dateObj.getMinutes().toString().padStart(2, '0');
	const seconds = dateObj.getSeconds().toString().padStart(2, '0');

	const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
	return formattedDate;
};

//
export const getReverseGraphTime = (formattedDate) => {
	const dateParts = formattedDate.split('T');
	const date = dateParts[0];
	const time = dateParts[1];

	const [year, month, day] = date.split('-');
	const [hours, minutes, seconds] = time.split(':');

	const reversedDate = new Date(year, month - 1, day, hours, minutes, seconds);
	return reversedDate;
};

// Gives Current Year in Graph Time Format
export const getCurrentYearFormatted = () => {
	const currentDate = new Date();
	const year = currentDate.getFullYear();
	const formattedDate = `${year}-01-01T00:00:00`;
	return formattedDate;
};

export const getCurrentMonthFormatted = () => {
	const currentDate = new Date();
	const month = currentDate.getMonth();
	const year = currentDate.getFullYear();
	const formattedDate = `${year}-${month}-01T00:00:00`;
	return formattedDate;
};

export const getDateRangeByPurposeAndFiTypes = (purposeCode, fiTypes, currentDateStr) => {
	const currentDate = new Date(currentDateStr);
	const fromDate = new Date(currentDate);
  
	const hasSEBI = fiTypes?.some(type => SEBI_FITYPES.includes(type));
	const hasInsurance = fiTypes?.some(type => INSURANCE_FITYPES.includes(type));
  
	switch (purposeCode) {
	  case "101":
		fromDate.setFullYear(currentDate.getFullYear() - 1);
		fromDate.setMonth(currentDate.getMonth() - (hasSEBI ? 0 : 1));
		break;
	  case "102":
		fromDate.setFullYear(currentDate.getFullYear() - 1);
		fromDate.setMonth(currentDate.getMonth() - (hasSEBI ? 0 : 1));
		break;
	  case "103":
		fromDate.setMonth(currentDate.getMonth() - 14);
		break;
	  case "104":
		fromDate.setMonth(currentDate.getMonth() - 6);
		break;
	  case "105":
		if (hasInsurance) {
		  fromDate.setMonth(currentDate.getMonth() - 12);
		} else {
		  fromDate.setMonth(currentDate.getMonth() - 6);
		}
		break;
	  default:
		console.log("default")
		fromDate.setMonth(currentDate.getMonth() - 6); // fallback
	}
  
	return {
	  fromTime: fromDate.toISOString(),
	  toTime: currentDate.toISOString()
	};
}
